$(document).ready(function () {


    //Setting Hot Level Class
    $('.c-sauce-tiles__heat-meter').each(function(){

        const heatLevel = $(this).attr('data-heat-level');
        const activeFlame = '<span class="c-sauce-tiles__heat-meter-flame active"></span>';
        const inactiveFlame = '<span class="c-sauce-tiles__heat-meter-flame"></span>';

        let flameHTML = '';

        for (let i = 1; i <= 5; i++) {
            if ( i <= heatLevel ) {
                flameHTML += activeFlame;
            } else {
                flameHTML += inactiveFlame;
            }
        }     

        $(this).html(flameHTML);

    });

    //Initiating Slider

    $('#sauces .c-sauce-tiles__slider-container').slick({
        dots: true,
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        responsive: [
            {
              breakpoint: 380,
              settings: {
                arrows: false,
                dots: true,
                centerMode: true,
                centerPadding: '0px',
                slidesToShow: 1
              }
            },
        ]
    });

    $('#rubs .c-sauce-tiles__slider-container').slick({
        dots: true,
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        responsive: [
            {
              breakpoint: 380,
              settings: {
                arrows: false,
                dots: true,
                centerMode: true,
                centerPadding: '0px',
                slidesToShow: 1
              }
            },
        ]
    });


}); //Document Ready End